module.exports = __webpack_public_path__ + "img/april-month.4c114275.png";